<template>
    <div class="interesting-contacts-container">
        <p class="title">Artists we think you'd like.</p>
        <div v-for="(item, indx) in contacts" :key="indx" class="interesting-contacts-item">
            <img class="contact-avatar" :src="contactAvatar(item)" alt="contact-avatar" />
            <p class="contact-name">
                {{ contactName(item) }}
            </p>
            <img
                @click="handleAddSuggestedContact(item)"
                :src="URLS.icons.addContact"
                class="add-contact-btn"
                alt="add-contact-icon"
            />
        </div>
    </div>
</template>
<script>
    import useProfileContacts from '@/composables/useProfileContacts.js'

    export default {
        name: 'InterestingContacts',
        props: {
            contacts: {
                required: true,
                type: Array
            }
        },
        emits: ['added-contact'],
        setup(props, context) {
            const { URLS, handleAddSuggestedContact } = useProfileContacts(props, context)

            return {
                URLS,
                handleAddSuggestedContact
            }
        },
        computed: {
            contactAvatar: (self) => (contact) =>
                (contact.avatar && contact.avatar.includes('/images/global/default.png')) ||
                !contact.avatar
                    ? self.URLS.icons.defaultContact
                    : contact.avatar,
            contactName: () => (contact) => {
                if (contact.band_name) return contact.band_name
                if (contact.venue_name) return contact.venue_name

                return contact.name
            }
        }
    }
</script>
<style lang="scss" scoped>
    .interesting-contacts-container {
        padding: 24px 24px 32px 24px;
        min-width: 336px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        background: #262626;
        border-radius: 15px;

        p {
            margin-bottom: 0px;
        }

        .title {
            color: white;
            font-family: Instrument Sans;
            font-size: 20px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            letter-spacing: -0.2px;
        }

        .interesting-contacts-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            width: 100%;

            .contact-avatar {
                object-fit: cover;
                width: 40px;
                height: 40px;
                border-radius: 15px;
            }
            .contact-name {
                margin-left: 12px;
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 650;
                line-height: 120%;
            }

            .add-contact-btn {
                cursor: pointer;
                width: 18px;
                height: 18px;
                background: transparent;
                margin-left: auto;
            }
        }
    }
</style>
